import { z } from 'zod'

export const PiloteCentralRecordZod = z.object({
  id: z.number(),
  name: z.string(),
  label: z.string().nullable(),
  description: z.string().nullable(),
  campaign_id: z.number().nullable(),
  is_mobile_request_enabled: z.boolean(),
  is_french_communication: z.boolean(),
  is_electronic_payment_enabled: z.boolean(),
  is_assisted_assignment_enabled: z.boolean().nullish().default(false),
  is_manual_wait_time_enabled: z.boolean().nullish().default(false),
  is_registration_open: z.boolean().optional().default(false),
  is_availabilities_required: z.boolean().nullish().default(false),
  is_odometer_photo_required: z.boolean().nullish().default(false),
  is_post_territory_enabled: z.boolean().nullish().default(false),
  active: z.boolean(),
  version: z.number(),
  mobile_transport_duration_threshold: z.number(),
  mobile_transport_wait_time_threshold: z.number(),
  roles: z.string().nullish(),
})
